function lcInitReveal() {
  const els = document.querySelectorAll('.lc-reveal:not(.lc-visible)');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof IntersectionObserver === 'undefined') {
    els.forEach((el) => el.classList.add('lc-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lc-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach((el, i) => {
    el.style.setProperty('--lc-delay', (i % 6) * 90 + 'ms');
    io.observe(el);
  });
  // Safety net: if the observer never fires (unusual embeds/browsers), don't leave content invisible forever.
  setTimeout(() => {
    document.querySelectorAll('.lc-reveal:not(.lc-visible)').forEach((el) => el.classList.add('lc-visible'));
  }, 2500);
}

function lcInitCountUp() {
  const els = document.querySelectorAll('[data-lc-countup]');
  if (!els.length) return;
  const run = (el) => {
    const target = parseFloat(el.dataset.lcCountup);
    if (isNaN(target)) return;
    const suffix = el.dataset.lcSuffix || '';
    const duration = 1400;
    const start = performance.now();
    function step(now) {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = target * eased;
      el.textContent = (Number.isInteger(target) ? Math.round(val) : val.toFixed(1)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => { el.textContent = el.dataset.lcCountup + (el.dataset.lcSuffix || ''); });
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        run(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach((el) => io.observe(el));
}

function lcInitGallery() {
  document.querySelectorAll('[data-lc-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-lc-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-lc-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.lcFull;
        if (!full) return;
        main.src = full;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
}

function lcInitVariants() {
  document.querySelectorAll('[data-lc-product-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-lc-variants-json]');
    const idInput = form.querySelector('input[name="id"]');
    const submitBtn = form.querySelector('[data-lc-submit]');
    const priceNow = form.querySelector('[data-lc-price-now]');
    const priceWas = form.querySelector('[data-lc-price-was]');
    const selects = form.querySelectorAll('[data-lc-option-select]');
    if (!dataEl || !idInput || !selects.length) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function findVariant() {
      const chosen = Array.from(selects).map((s) => s.value);
      return variants.find((v) => v.options.every((opt, i) => opt === chosen[i]));
    }

    function setSubmitText(text) {
      if (!submitBtn) return;
      const label = submitBtn.querySelector('.lc-addtocart__text');
      if (label) { label.textContent = text; } else { submitBtn.textContent = text; }
    }

    function update() {
      const variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; setSubmitText(submitBtn.dataset.lcUnavailable || 'No disponible'); }
        return;
      }
      idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          setSubmitText(submitBtn.dataset.lcAvailable || 'Añadir al carrito');
        } else {
          submitBtn.disabled = true;
          setSubmitText(submitBtn.dataset.lcSoldout || 'Agotado');
        }
      }
    }

    selects.forEach((s) => s.addEventListener('change', update));
    update();
  });
}

document.documentElement.classList.add('lc-js');

function lcInitAll() {
  lcInitReveal();
  lcInitCountUp();
  lcInitGallery();
  lcInitVariants();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lcInitAll);
} else {
  lcInitAll();
}
